import getREMFromPX from "../../../utils/getREMFromPX";
import StarIcon from "@mui/icons-material/Star";
import StarOutlineIcon from "@mui/icons-material/StarOutline";
import { theme } from "../../../theme";
import { getThemePath } from "../../../hooks/useGetThemePath";

const themePath = getThemePath();
const colors = theme[themePath].colors;

export const renderStars = (
  averageStars: string,
  size?: number,
  customMargin?: string
) => {
  const stars = [];
  const filledStars = Number(averageStars) > 5 ? 5 : parseInt(averageStars);
  const remainingStars = 5 - filledStars;

  for (let i = 0; i < filledStars; i++) {
    stars.push(
      <StarIcon
        key={i}
        sx={{
          color: colors.icons.default.starFillColor,
          fontSize: getREMFromPX(size ?? 21),
          marginRight: customMargin ?? "8px",
        }}
      />
    );
  }

  for (let i = 0; i < remainingStars; i++) {
    stars.push(
      <StarOutlineIcon
        key={i + filledStars}
        sx={{
          color: colors.icons.default.fillColor,
          fontSize: getREMFromPX(size ?? 21),
          marginRight: customMargin ?? "8px",
        }}
      />
    );
  }

  return stars;
};
